import { motion } from "motion/react"

import { i18n } from "@/i18n"
import { useModalStore } from "@/store"
import { Modal } from "../Modal"

import styles from "./index.module.scss"

export const SkinModal: React.FC = () => {
    const open = useModalStore((state) => state.skinOpen)
    const onCancel = useModalStore((state) => state.closeSkin)

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            showCancelBtn={false}
            showOkBtn={false}
            contentClassName={styles.skin}
        >
            <div className={styles.title}>
                <span>{i18n.get("map.skin.title")}</span>
            </div>
            <div className={styles.skinImage} />
            <motion.div
                className={styles.logo}
                initial={{ opacity: 0, x: -120 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                    opacity: { duration: 1.2, ease: "easeOut" },
                    x: { duration: 5, ease: "easeOut" },
                }}
            />
            <motion.div
                className={styles.info}
                initial={{ opacity: 0, x: 120 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                    opacity: { duration: 1.2, ease: "easeOut" },
                    x: { duration: 5, ease: "easeOut" },
                }}
            >
                <div className={styles.charName}>
                    <span>{i18n.get("map.skin.charName")}</span>
                </div>
                <div className={styles.skinName}>
                    <span>{i18n.get("map.skin.skinName")}</span>
                </div>
            </motion.div>
            <div className={styles.tips}>
                <span>{i18n.get("map.skin.tips")}</span>
            </div>
        </Modal>
    )
}
